import { render, staticRenderFns } from "./GaugeSchema.vue?vue&type=template&id=9674f7de&"
import script from "./GaugeSchema.vue?vue&type=script&lang=ts&"
export * from "./GaugeSchema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports